// Hide Google's own POI labels/markers (also applied in dark mode).
export const HIDE_POI_LABELS = { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] };

// Google Maps styles for the /map view: soft pastel land, water and roads so the
// category-colored markers stand out. These are map rendering colors, not brand
// tokens, so they are shared by every white label. Later rules override earlier ones.
const MAP_STYLES = [
  HIDE_POI_LABELS,
  { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#f4f1ea" }] },
  { featureType: "landscape.man_made", elementType: "geometry", stylers: [{ color: "#efece4" }] },
  { featureType: "poi", elementType: "geometry", stylers: [{ color: "#ece9e1" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#d7ecd1" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9e4f2" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#7a9fb5" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
  { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#fbe7c6" }] },
  { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#f2d4a4" }] },
  // Street names: dark gray with an explicit white halo, so they stay crisp on the
  // white roads and the pastel highways when zooming in.
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#5f6368" }] },
  { featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }, { weight: 3 }] },
  { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e3dff0" }] },
  { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#6b6b6b" }] },
];

export default MAP_STYLES;
